import classDetail from './classDetail'
import classEnroll from './classEnroll'
import classPay from './classEnroll/classPay'
import enrollSuccess from './classEnroll/enrollSuccess'
import enrollSuccessToAudit from './classEnroll/enrollSuccessToAudit'
const homeClass = {
  path: 'homeClass/:classId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/homeClass'], resolve),
  redirect: 'homeClass/classDetail',
  children: [
    classDetail,
    classEnroll,
    classPay,
    enrollSuccess,
    enrollSuccessToAudit
  ]
}
export default homeClass



// WEBPACK FOOTER //
// ./src/router/pages/student_user/homeClass/index.js